import React, { useState, useEffect } from "react";
import CustomTextField from "../../../components/Textfield";
import Button from "../../../components/Button";
import UploadImage from "../../../components/UploadImage";
import { useDispatch, useSelector } from "react-redux";
import { updateProfile } from "../../../http/auth";
import { showToast } from "../../../store/slices/common";
import Spinner from "../../../components/Spinner";
import { Typography } from "@mui/material";

const EditProfile = ({ smScreen }) => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.common.userDetails);

  const [formData, setFormData] = useState({ name: "", profile: "" });
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setFormData({ name: user?.name });
  }, [user]);

  const onChangeHandler = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    checkValidation();
  };

  const onChangeImage = (profile) => {
    setFormData({ ...formData, profile });
    checkValidation();
  };

  const checkValidation = () => {
    formData.name && (formData.profile || user?.profilePicture) ? setDisabled(false) : setDisabled(true);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const payload = new FormData();
      if (formData.name) payload.append("name", formData.name);
      if (formData.profile) payload.append("profile", formData.profile);
      await updateProfile(payload);
      dispatch(
        showToast({ color: "success", msg: "Profile updated successfully" })
      );
      setDisabled(true);
      setLoading(false);
    } catch (error) {
      dispatch(
        showToast({
          color: "error",
          msg: error.response?.data?.message || "Profile update failed",
        })
      );
      setLoading(false);
    }
  };

  return (
    <div className="">
      {loading && <Spinner />}
      <form>
        <Typography sx={{ fontSize: "18px" }}>
          Profile Picture<span style={{ color: "red" }}>*</span>
        </Typography>
        <UploadImage
          id="profile-image"
          image={formData.profile || user?.profilePicture}
          onChange={onChangeImage}
          style={{
            height: smScreen ? "140px" : "200px",
            width: smScreen ? "140px" : "200px",
            iconWidth: smScreen ? "30px" : "36px",
            iconHeight: smScreen ? "30px" : "36px",
            iconRight: smScreen ? "-15px" : "-18px",
            marginBottom: "1rem",
          }}
        />
        <Typography sx={{ fontSize: "18px" }}>
          Name<span style={{ color: "red" }}>*</span>
        </Typography>
        <CustomTextField
          type="text"
          name="name"
          placeholder="Name"
          variant="outlined"
          value={formData.name}
          onChange={onChangeHandler}
          style={{ maxWidth: "400px", width: "100%", margin: "5px 0 20px" }}
        />
        <br />
        <Button
          label="Submit"
          type="submit"
          variant="contained"
          className={"imagecropbtns"}
          style={{ width: "20%", minWidth: "150px" }}
          color="primary"
          onClick={onSubmit}
          disabled={disabled}
        />
      </form>
    </div>
  );
};

export default EditProfile;
